/**
 * Login page – email/password. No Firebase in component; uses auth use case.
 */
import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { signIn } from '../../domain/usecases/auth';
import Card from '../../shared/ui/Card.jsx';
import Input from '../../shared/ui/Input.jsx';
import Button from '../../shared/ui/Button.jsx';
import Display from '../../shared/ui/Display.jsx';
import Body from '../../shared/ui/Body.jsx';
import styles from './AuthPages.module.css';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect') || '/';

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signIn(email, password);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.wrap}>
      <Card padding="lg" className={styles.card}>
        <img src="/logo.png" alt="BarChain" className={styles.logo} />
        <Display as="h1" size="l" style={{ textAlign: 'center', marginBottom: '0.25rem' }}>
          BarChain
        </Display>
        <Body tone="secondary" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          Lift. Compete. Dominate.
        </Body>

        <form onSubmit={handleSubmit} className={styles.form}>
          <Input
            label="EMAIL"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
          <Input
            label="PASSWORD"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          {error && (
            <Body tone="secondary" style={{ color: 'var(--red-platform)' }}>
              {error}
            </Body>
          )}
          <Button
            variant="primary"
            size="lg"
            type="submit"
            disabled={loading}
            style={{ width: '100%' }}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>

        <div className={styles.footer}>
          <Button
            variant="ghost"
            size="md"
            as={Link}
            to={redirectTo ? `/signup?redirect=${encodeURIComponent(redirectTo)}` : '/signup'}
          >
            Create an account
          </Button>
        </div>
      </Card>
    </div>
  );
}
